import { render } from "./MyCourses.vue?vue&type=template&id=507b2a30&scoped=true"
import script from "./MyCourses.vue?vue&type=script&lang=js"
export * from "./MyCourses.vue?vue&type=script&lang=js"

import "./MyCourses.vue?vue&type=style&index=0&id=507b2a30&scoped=true&lang=scss"

import exportComponent from "D:\\work\\ocs\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507b2a30"]])

export default __exports__